function sticky_relocate() {
  var window_top = $(window).scrollTop();
  var div_top = $('.product-form__quantity-and-buy-buttons-wrapper').offset().top;
    var aa = $(".header__background-container").height();
    var bb = $(".product-form__quantity-and-buy-buttons-wrapper").height();
    var nn = div_top - aa + bb;
  if (window_top > nn) {
    $('#kg-bottom-card-section').addClass('kg-bottom-sticky');
    $('.product-form__controls-group--submit').addClass('kg-bottom-sticky');
  } else {
    $('#kg-bottom-card-section').removeClass('kg-bottom-sticky');
    $('.product-form__controls-group--submit').removeClass('kg-bottom-sticky');
  }
}

$(function() {
  $(window).scroll(sticky_relocate);
  sticky_relocate();
});
